<template>
  <div class="m-pc-banner">
    <div class="banner-img">
      <a @click="toNewPager(template.meetingInfo.banner_href.text.value)">
        <img :src="template.meetingInfo.banner.src.value" alt="背景图" />
      </a>
    </div>
    <div class="meeting-info">
      <div
        class="metting-name"
        v-bind:style="{ color: template.meetingInfo.webinar_title.color.value }"
        v-if="template.meetingInfo.webinar_title.display.value"
      >
        {{ webinarInfo.title }}
      </div>
      <div
        class="metting-date"
        v-show="!ReplayliveState"
        v-bind:style="{
          color: template.meetingInfo.webinar_time
            ? template.meetingInfo.webinar_time.color.value
            : '#fff'
        }"
        v-if="
          (template.meetingInfo.webinar_time
            ? template.meetingInfo.webinar_time.display.value
            : true) && webinarInfo.replaySwitch !== 1
        "
      >
        {{ time }}
      </div>
    </div>
    <div class="banner-navs" id="pc-banner-navs">
      <ul class="nav-list">
        <li v-if="template.meetingInfo.tab_1_p.display.value">
          <a @click="scrollTo('intro')">{{
            template.meetingInfo.tab_1_p.text.value
          }}</a>
        </li>
        <li v-if="template.meetingInfo.tab_2_p.display.value">
          <a @click="scrollTo('agenda')">{{
            template.meetingInfo.tab_2_p.text.value
          }}</a>
        </li>
        <li v-if="template.meetingInfo.tab_3_p.display.value">
          <a @click="scrollTo('guest')">{{
            template.meetingInfo.tab_3_p.text.value
          }}</a>
        </li>
        <li v-if="template.meetingInfo.tab_4_p.display.value">
          <a @click="scrollTo('custom')">
            {{ template.meetingInfo.tab_4_p.text.value }}
          </a>
        </li>
      </ul>
      <div
        class="count-down"
        v-show="!ReplayliveState"
        v-bind:style="{ color: template.meetingInfo.countdown.color.value }"
      >
        <span>{{ webinarStatusTitle || "距离会议开始开始还有" }}</span>
        <van-count-down
          :time="allTime"
          class="vant-count"
          v-bind:style="{ color: template.meetingInfo.countdown.color.value }"
          v-if="webinarInfo.replaySwitch !== 1"
        >
          <template v-slot="timeData">
            <strong>{{ timeData.days }}</strong>
            <span>天</span>
            <strong>{{ timeData.hours }}</strong>
            <span>小时</span>
            <strong>{{ timeData.minutes }}</strong>
            <span>分</span>
            <strong>{{ timeData.seconds }}</strong>
            <span>秒</span>
          </template>
        </van-count-down>
        <div class="meeting-right-btn">
          <span
            v-if="webinarInfo.replaySwitch !== 1 && !ReplayliveState"
            class="m-button"
            @click="joinBtnClick"
            v-bind:style="{
              color: template.meetingInfo.btn_join.color.value,
              backgroundColor:
                template.meetingInfo.btn_join.backgroundColor.value
            }"
          >
            {{
              template.meetingInfo.btn_join.text.value == "立即参会"
                ? signUpTextStatus || "立即参会"
                : template.meetingInfo.btn_join.text.value
            }}
          </span>
          <span
            v-if="webinarInfo.replaySwitch == 1 && !ReplayliveState"
            class="m-button"
            @click="joinBtnClick"
            v-bind:style="{
              color: template.meetingInfo.btn_join.color.value,
              backgroundColor:
                template.meetingInfo.btn_join.backgroundColor.value
            }"
          >
            {{
              template.meetingInfo.btn_join.text.value == "立即参会"
                ? signUpTextStatus || "立即参会"
                : template.meetingInfo.btn_join.text.value
            }}
          </span>
          <span
            v-if="ReplayliveState"
            class="m-button"
            v-bind:style="{
              color: template.meetingInfo.btn_join.color.value,
              backgroundColor:
                template.meetingInfo.btn_join.backgroundColor.value
            }"
          >
            直播回放
          </span>
        </div>
      </div>
    </div>
    <div class="banner-flxed hide" id="pc-banner-flxed">
      <div
        class="left-date"
        v-bind:style="{ color: template.meetingInfo.countdown.color.value }"
      >
        <span>{{ webinarStatusTitle }}</span>
        <van-count-down
          :time="allTime"
          class="vant-count"
          @finish="finish"
          @change="changeCountDown"
          v-show="this.webinarStatusTitle !== '会议已经结束'"
        >
          <template v-slot="timeData">
            <strong>{{ timeData.days }}</strong>
            <span>天</span>
            <strong>{{ timeData.hours }}</strong>
            <span>小时</span>
            <strong>{{ timeData.minutes }}</strong>
            <span>分</span>
            <strong>{{ timeData.seconds }}</strong>
            <span>秒</span>
          </template>
        </van-count-down>
      </div>

      <ul class="center-navs">
        <li v-if="template.meetingInfo.tab_1_p.display.value">
          <a @click="scrollTo('intro')">{{
            template.meetingInfo.tab_1_p.text.value
          }}</a>
        </li>
        <li v-if="template.meetingInfo.tab_2_p.display.value">
          <a @click="scrollTo('agenda')">{{
            template.meetingInfo.tab_2_p.text.value
          }}</a>
        </li>
        <li v-if="template.meetingInfo.tab_3_p.display.value">
          <a @click="scrollTo('guest')">{{
            template.meetingInfo.tab_3_p.text.value
          }}</a>
        </li>
        <li v-if="template.meetingInfo.tab_4_p.display.value">
          <a @click="scrollTo('custom')">{{
            template.meetingInfo.tab_4_p.text.value
          }}</a>
        </li>
      </ul>

      <div class="right-btn">
        <span
          class="m-button"
          @click="joinBtnClick"
          v-if="webinarInfo.replaySwitch !== 1 && !ReplayliveState"
          v-bind:style="{
            color: template.meetingInfo.btn_join.color.value,
            backgroundColor: template.meetingInfo.btn_join.backgroundColor.value
          }"
        >
          {{
            template.meetingInfo.btn_join.text.value == "立即参会"
              ? signUpTextStatus
              : template.meetingInfo.btn_join.text.value
          }}
        </span>
        <span
          v-if="webinarInfo.replaySwitch == 1 && !ReplayliveState"
          class="m-button"
          @click="joinBtnClick"
          v-bind:style="{
            color: template.meetingInfo.btn_join.color.value,
            backgroundColor: template.meetingInfo.btn_join.backgroundColor.value
          }"
        >
          {{
            template.meetingInfo.btn_join.text.value == "立即参会"
              ? signUpTextStatus || "立即参会"
              : template.meetingInfo.btn_join.text.value
          }}
        </span>
        <span
          v-if="ReplayliveState"
          class="m-button"
          v-bind:style="{
            color: template.meetingInfo.btn_join.color.value,
            backgroundColor: template.meetingInfo.btn_join.backgroundColor.value
          }"
        >
          直播回放
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { $subscriber, URLS } from "fire-wind-water";
import $ from "jquery";
import { validateState } from "@/common/joinMeeting";
import moment from "moment";
import { mixinsTemplate } from "../../common/mixinsTemplate";

export default {
  name: "Banner",
  mixins: [mixinsTemplate],
  data() {
    return {
      time: "",
      allTime: "",
      webinarStatusTitle: "",
      webinarInfo: {},
      userInfo: {},
      ReplayliveState:
        window.location.href.indexOf("liveState=replay") > -1 &&
        window.location.href.indexOf("isSetting=1") > -1
          ? true
          : false, //静态链接回放状态
      signUpTextStatus: ""
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
        this.time =
          moment(data.startTime).format("YYYY年MM月DD日 HH:mm") +
          "-" +
          moment(data.endTime).format("HH:mm");
      });
      $subscriber.subscribe("signUpTextStatus", data => {
        this.signUpTextStatus = data;
      });
      $subscriber.subscribe("userInfo", data => {
        this.userInfo = data;
        console.log("userInfo", this.userInfo);
      });
      $subscriber.subscribe("onCountdown", () => {
        this.countdown();
      });
      let self = this;
      $subscriber.subscribe("SetScrollDone", () => {
        //        let dom = $(".gm-scroll-view");  滚动条兼容问题
        let dom = $(document);
        dom.scroll(() => {
          if (self.dom.getBoundingClientRect().top < 0) {
            self.dom1.classList.remove("hide");
            $subscriber.emit("ShowPcBackTop");
          } else {
            self.dom1.classList.add("hide");
            $subscriber.emit("HidePcBackTop");
          }
        });
      });
    },
    //计算时间
    countdown() {
      if (this.webinarInfo.serverTime < this.webinarInfo.startTime) {
        this.webinarStatusTitle = "距离会议开始还有"; //未开始
        this.allTime = this.webinarInfo.startTime - this.webinarInfo.serverTime;
      } else if (
        this.webinarInfo.startTime <= this.webinarInfo.serverTime &&
        this.webinarInfo.serverTime < this.webinarInfo.endTime
      ) {
        this.webinarStatusTitle = "距离会议结束还有"; //进行中
        this.allTime = this.webinarInfo.endTime - this.webinarInfo.serverTime;
      } else {
        this.webinarStatusTitle = "会议已经结束"; //已结束
      }
    },
    async joinBtnClick() {
      let info = window.$sk.webinar.get().meetingInfo;
      let webinarInfo = Object.assign(this.webinarInfo, info);
      let userInfo = Object.assign(
        this.userInfo,
        window.$sk.webinar.get().user
      );
      //验证用户状态  审核中 未通过 无权限  会议已经关闭 会场未发布
      if (window.$sk.webinar.get().canJoin(webinarInfo, userInfo)) {
        if (window.$sk.webinar.get().canEnter(webinarInfo, userInfo)) {
          //可进入会场
          window.$sk.goto(
            window.location.href.replace("/meetingInfo", "/meeting")
          );
        } else {
          let returnUrl = window.location.href;
          if (!webinarInfo.isClosed) {
            returnUrl = window.location.href.replace(
              "/meetingInfo",
              "/meeting"
            );
          }
          if (
            !webinarInfo.isClosed &&
            !webinarInfo.unLimit &&
            webinarInfo.needLogin &&
            !userInfo.isLogin &&
            !webinarInfo.isClosed &&
            !webinarInfo.unLimit &&
            webinarInfo.needRegistration &&
            !userInfo.isRegistration
          ) {
            window.$sk.goto(
              webinarInfo.loginUrl +
                "sourceKey=" +
                URLS.getURL("sourceKey") +
                "&backUrl=" +
                encodeURIComponent(webinarInfo.goToSignUpUrl)
            );
          } else if (
            !webinarInfo.isClosed &&
            !webinarInfo.unLimit &&
            webinarInfo.needLogin &&
            !userInfo.isLogin
          ) {
            window.$sk.goto(
              webinarInfo.loginUrl +
                "sourceKey=" +
                URLS.getURL("sourceKey") +
                "&backUrl=" +
                encodeURIComponent(returnUrl)
            );
          } else if (
            !webinarInfo.isClosed &&
            !webinarInfo.unLimit &&
            webinarInfo.needRegistration &&
            !userInfo.isRegistration
          ) {
            window.$sk.goto(webinarInfo.goToSignUpUrl);
          } else {
            window.$sk.goto(returnUrl);
          }
        }
      } else {
        if (this.webinarInfo.isOnDemand) {
          window.$sk.goto(webinarInfo.demandUrl);
        } else {
          validateState(webinarInfo, this.userInfo);
        }
      }
    },
    scrollTo(position) {
      //      let scrollDom = $(".gm-scroll-view"); //滚动条兼容问题
      let scrollDom = $("html,body");
      let toDom = $("#" + position);
      let fixHeader = $(".banner-flxed").height();

      //      scrollDom.animate(// 滚动条兼容问题
      //        { scrollTop: toDom.offset().top + scrollDom.scrollTop() - fixHeader },
      //        1500
      //      );
      scrollDom.animate(
        { scrollTop: toDom.offset().top - (fixHeader || 80) },
        1500
      );
    },
    finish() {
      ///监听倒计时结束时间
      console.log("倒计时结束");
      this.countdown();
    },
    toNewPager(href) {
      if (href && href !== "") {
        window.open(href);
      }
    },
    ///倒计时开始发生变化
    changeCountDown() {
      console.log("倒计时 开始发生变化");
      this.webinarInfo.serverTime += 1000;
    }
  },
  mounted() {
    this.dom = this.$el.querySelector("#pc-banner-navs");
    this.dom1 = this.$el.querySelector("#pc-banner-flxed");
  }
};
</script>

<style scoped></style>
